var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flight-map',{ref:"mapRef",attrs:{"edit-mode":false}},[_c('fly-router',{ref:"path",attrs:{"task":_vm.mission.tasks,"edit-mode":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }